import { render, staticRenderFns } from "./fxfbs.vue?vue&type=template&id=7bbe4f26&scoped=true&"
import script from "./fxfbs.vue?vue&type=script&lang=js&"
export * from "./fxfbs.vue?vue&type=script&lang=js&"
import style0 from "./fxfbs.vue?vue&type=style&index=0&id=7bbe4f26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbe4f26",
  null
  
)

export default component.exports